export default __webpack_public_path__ + "media/titles/title_2_locale_es-251fd5ed.png";